import { IActivity } from 'FeatureModules/Activity/types/activity.types';
import { IMinBaseChain } from 'FeatureModules/ComponentChain/types/chain.types';
import { IComponentItem } from 'FeatureModules/ComponentChain/types/component.types';
import { ICompanyLog, IAddress, IBaseCompany } from 'FeatureModules/Auth/types/company.types';
import { IGraphQlConnection } from 'types/core.types';
import { ICompanyUser } from '../../Auth/types/companyUser.types';
import { IBaseDocument } from '../../Document/types/document.types';
import { ImpactClaim } from '../../Request/types/impactClaim.types';
import { ISite } from '../../Site/types/site.types';

export enum ERequestType {
  CHAIN = 'CHAIN',
  DOCUMENT = 'DOCUMENT',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
}

export enum EPartnerRequestLogAction {
  DENIED = 'DENIED',
  PROVIDED = 'PROVIDED',
  DELETED = 'DELETED',
  REQUESTED = 'REQUESTED',
  EDITED = 'EDITED',
  COMPLETED = 'COMPLETED',
}

export enum EPartnerRequestStatus {
  DELETED = 'DELETED',
  DENIED = 'DENIED',
  DENIED_COMPLETED = 'DENIED_COMPLETED',
  PROVIDED = 'PROVIDED',
  PROVIDED_COMPLETED = 'PROVIDED_COMPLETED',
  REQUESTED = 'REQUESTED',
  EDITED = 'EDITED',
}

export enum EPartnerRequestDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export type TRequestType = `${ERequestType}`;

export type TPartnerRequestLogAction = `${EPartnerRequestLogAction}`;

export type TPartnerRequestStatus = `${EPartnerRequestStatus}`;

export type TPartnerRequestDirection = `${EPartnerRequestDirection}`;

export type IBasePartnerCompany = IBaseCompany;

export interface IBasePartnerCompanyWithAddress extends IBasePartnerCompany {
  address?: IAddress;
}

export interface IPartnerCompanySummary extends IBasePartnerCompany {
  sitesCount: number;
  activitiesCount: number;
}

/**
 * Be extremely careful when using this type, as it is quite a big query to get this data.
 */
export interface IPartnerCompany extends IBasePartnerCompany {
  logs: ICompanyLog[];
  latestLog: ICompanyLog | null;
  /** This is only a preview of the items, we only fetch the three latest of each */
  impactClaims: IGraphQlConnection<ImpactClaim>;
  sites: IGraphQlConnection<ISite>;
  activities: IGraphQlConnection<IActivity>;
  requests: IGraphQlConnection<IPartnerRequest>;
  sharedDocuments: IGraphQlConnection<IBaseDocument>;
  components: IGraphQlConnection<IComponentItem>;
}

export interface IPartnerRequestForm {
  requestTitle: string;
  requestMessage: string;
  requestType: TRequestType;
  requestedToCompanyId: string;
  componentId?: string;
  questionnaireId?: string;
}

export interface IPartnerRequestLog {
  id: string;
  comment: string;
  userEmail: string;
  user: ICompanyUser;
  company: IBasePartnerCompany;
  timestamp: Date;
  action: TPartnerRequestLogAction;
}

export interface IPartnerRequest {
  id: string;
  requestedByUserId: string;
  documentId?: string;
  requestTitle: string;
  requestMessage: string;
  requestReplyMessage?: string;
  direction: TPartnerRequestDirection;
  requestStatus: TPartnerRequestStatus;
  requestedTimestamp: Date;
  requestedToCompany: IBasePartnerCompany;
  requestedFromCompany: IBasePartnerCompany;
  user: ICompanyUser;
  document?: IBaseDocument;
  latestLog: IPartnerRequestLog;
  logs: IPartnerRequestLog[];
  previouslyUploadedDocuments?: IBaseDocument[];
  requestType: TRequestType;
  componentId?: string;
  chainId?: string;
  chain?: IMinBaseChain;
  questionnaireCompanyResponseId?: string;
  questionnaireId?: string;
  proofDocuments?: IBaseDocument[];
}

export interface IUpdatePartnerRequest {
  partnerRequest: IPartnerRequest;
}
